import * as Joi from 'joi';
import { Moment } from 'moment';
import {
	Column,
	Entity,
	JoinColumn,
	OneToOne,
	PrimaryGeneratedColumn,
	ManyToOne,
} from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import DepartmentPermissionEntity from '../department-permissions/department-permission.entity';
import { DEPARTMENTS } from '../enums/enums';
import Permission from '../permissions/permission.entity';
import User from '../users/user.entity';

@Entity('mu_permissions')
export default class MuPermission extends DepartmentPermissionEntity {
	static tableName = 'mu_permissions';
	static deptId = DEPARTMENTS.MU;

	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	perm_id: number;

	@Column('int')
	user_id: number;

	@Column('int')
	episodic_id: number;

	@Column('int')
	department_head: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column('int')
	admin_access: number;

	@Column('int')
	edit_data: number;

	@Column('tinyint')
	fitting_research: number;

	@Column('int')
	created_by: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@ManyToOne((type) => User, (user) => user.muPermissions)
	@JoinColumn({ name: 'user_id' })
	user: User;

	@OneToOne((type) => Permission, (permission) => permission.muPermission)
	@JoinColumn({
		name: 'perm_id',
	})
	permission: Permission;

	readonly department = MuPermission.deptId;

	static rules() {
		return {
			id: Joi.number().integer(),
			perm_id: Joi.number().integer().allow(null),
			user_id: Joi.number().integer().allow(null),
			episodic_id: Joi.number().integer().allow(null),
			department_head: Joi.number().integer(),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			admin_access: Joi.number().integer(),
			edit_data: Joi.number().integer(),
			fitting_research: Joi.number().integer().max(9),
			created_by: Joi.number().integer().allow(null),
			date_created: Joi.date().allow(null),
		};
	}

	toJSON() {
		return {
			id: this.id,
			perm_id: this.perm_id,
			user_id: this.user_id,
			episodic_id: this.episodic_id,
			department: this.department,
			department_head: this.department_head,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			admin_access: this.admin_access,
			edit_data: this.edit_data,
			fitting_research: this.fitting_research,
			created_by: this.created_by,
			date_created: this.date_created,
		};
	}

	assign(props?: GenPartial<MuPermission>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<MuPermission>) {
		super(props);
	}
}
